<!-- TEMPORARY MAINTENANCE BANNER — Home, Crosstab and Brand Analysis only. -->
<div class="maintenance-layout" [class.maintenance-layout--enabled]="isMaintenanceBannerVisible">
  <aside *ngIf="isMaintenanceBannerVisible" class="maintenance-banner" aria-label="Scheduled maintenance">
    <svg class="maintenance-banner__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
      <path d="M12 3 2 21h20L12 3Z"></path>
      <path d="M12 9v5"></path>
      <path d="M12 17h.01"></path>
    </svg>
    <span class="maintenance-banner__message">
      Explorer+ will be under maintenance on 25th October from 8:00 AM to 10:00 AM IST.
    </span>
    <button type="button" class="maintenance-banner__close" aria-label="Dismiss maintenance notice"
      (click)="maintenanceBannerDismissed = true">
      <span aria-hidden="true">&times;</span>
    </button>
  </aside>
  <div class="maintenance-page-content">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- END TEMPORARY MAINTENANCE BANNER — retain router-outlet when removing. -->

<app-loader></app-loader>
<app-error-alert-popup></app-error-alert-popup>
<app-error-alert-popup-ctba></app-error-alert-popup-ctba>
<app-toast></app-toast>

<!-- Global SVG Definitions -->
<svg width="0" height="0" style="position:absolute; width:0; height:0;">
  <defs>
    <linearGradient id="askme-gradient" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#8600CD" />
      <stop offset="100%" stop-color="#1110EB" />
    </linearGradient>
  </defs>
</svg>
